import React, { useState, useRef, useEffect } from 'react';
import { usePdf } from '@mikecousins/react-pdf';
import { Button } from 'reactstrap';
import { ChevronRight, ChevronLeft, ZoomIn, ZoomOut} from '@material-ui/icons';
import ExpandIcon from '../../../../../assets/images/module/general/ExpandIcon.svg';
import { Group, Stack } from '@mantine/core';
import Autoload from '../../../../Autoload';

const MOBILE_SIZE = 992;
const SMALLER_MOBILE_SIZE = 500;
var { loader, downloadDocument, generateFileNameForMessagePdf } = Autoload.MainHelper;

const PostviewMessageTenantPortal = ({selectedRecipient, senderEmail, senderProfile, propertySelected, accountData, rentalUnits, messageData, isMobile}) => {
  const [rentalUnit, setRentalUnit] = useState();
  const [propertyAddress, setPropertyAddress] = useState();

  useEffect(()=> {
    let rentalUnit = rentalUnits.find((ru)=> ru.tenantsData.find((tenant)=> tenant.id === selectedRecipient.tenantId) !== undefined);
    setRentalUnit(rentalUnit);

    if(propertySelected?.isPropertyOwnerInfoEnabled && propertySelected?.isPropertyOwnerInfoInMessagesEnabled){
      const {propertyOwner} = propertySelected;
      let newSenderAddress = {
        name: propertyOwner?.name,
        street: propertyOwner?.street,
        postalCode: propertyOwner?.postalCode,
        city: propertyOwner?.city,
        phoneNumber: propertyOwner?.pboneNumber,
        email: propertyOwner?.email
      }
      setPropertyAddress(newSenderAddress)
    }else{
      let newSenderAddress = {
        name: accountData?.addressCompany,
        street: accountData?.addressStreet,
        postalCode: accountData?.addressZipCode,
        city: accountData?.addressCity,
        phoneNumber: accountData?.companyPhoneNumber,
        email: accountData?.companyEmail
      }
      setPropertyAddress(newSenderAddress)
    }
  },[selectedRecipient])

  return (
    <div style={{width: isMobile ? '90mm' : '210mm', //height: '297mm', 
    background: 'white', //boxShadow: '0px 1px 2px #000', 
    padding: isMobile ? '7mm' : '23mm'}}>
      <Group gap={2}>
            <span style={{fontSize: isMobile ? '12px' : '16px', fontWeight: 600, fontFamily: 'Arial', textAlign: 'justify', color: '#000'}}>Betreff:</span>
            <div className={'message-card-title'} style={{fontSize: isMobile ? '12px' : '16px', fontWeight: 600, fontFamily: 'Arial', textAlign: 'justify', color: '#000'}} dangerouslySetInnerHTML={{__html: selectedRecipient.subject}}/>  
        </Group>
      <div className='div-message-preview-body' style={{marginTop: isMobile ? '5mm' : '20mm', fontSize: isMobile ? '10px' : '12px', fontFamily: 'Arial', textAlign: 'justify'}} dangerouslySetInnerHTML={{__html: selectedRecipient.body}}/>
      <Stack gap={10}>
        <Stack gap={0}>
            <span style={{fontFamily: 'Arial', fontSize: isMobile ? '8pt' : '9pt'}}>{propertyAddress?.name}</span>
            <span style={{fontFamily: 'Arial', fontSize: isMobile ? '8pt' : '9pt'}}>{propertyAddress?.street}</span>
            <span style={{fontFamily: 'Arial', fontSize: isMobile ? '8pt' : '9pt'}}>{`${propertyAddress?.postalCode} ${propertyAddress?.city}`}</span>
            {propertyAddress?.phoneNumber && <span style={{fontFamily: 'Arial', fontSize: isMobile ? '7pt' : '8pt'}}>{`Telefon: ${propertyAddress?.phoneNumber}`}</span>}
            {propertyAddress?.email && <span style={{fontFamily: 'Arial', fontSize: isMobile ? '7pt' : '8pt'}}>{`E-Mail: ${propertyAddress?.email}`}</span>}
        </Stack>
      </Stack>
      <Stack style={{fontSize: '12px', fontWeight: 400, marginTop: '20px'}} gap={0}>
        {selectedRecipient?.documentId &&
        <Group gap={2} style={{fontSize: isMobile ? '10px' : '12px'}}><span style={{fontWeight: 'bold'}}>Anhang:</span><span style={{cursor: 'pointer', marginLeft: '1px', color: '#5555FF'}} onClick={()=> downloadDocument(selectedRecipient, messageData)}>{generateFileNameForMessagePdf(selectedRecipient, messageData)}</span></Group>}
      </Stack>
    </div>
  );
};

export default PostviewMessageTenantPortal;